import {
    CHECK_LISTING_START,
    CHECK_LISTING_SUCCESS,
    CHECK_LISTING_ERROR
} from '../../constants';
import { checkListing as query } from '../../lib/graphql';

export function checkListing(id, type) {
    return async (dispatch, getState, { client }) => {
        dispatch({
            type: CHECK_LISTING_START,
        });

        try {
            const { data } = await client.query({
                query,
                variables: { id: Number(id), type },
                fetchPolicy: 'network-only'
            })

            if (data?.checkListing?.status === '200') {
                dispatch({
                    type: CHECK_LISTING_SUCCESS,
                });
                return  true;
            } else {
                dispatch({
                    type: CHECK_LISTING_ERROR,
                });
                return false;
            }

        } catch (error) {
            dispatch({
                type: CHECK_LISTING_ERROR,
            });
            return false;
        }
    }
}